import InputField from "components/fields/InputField";
import Default from "layouts/auth/types/Default";
// import { FcGoogle } from "react-icons/fc";
// import { FaApple } from "react-icons/fa";
// import { FaFacebook } from "react-icons/fa";
import Checkbox from "components/checkbox";
import { useAuth } from "hooks/useAuth";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AtriumApi from "api";
import toast from "react-hot-toast";
import Loader from "components/loader/Loader";
import axios from "axios";

function SignInDefault() {
  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const emailRef = useRef();
  const passwordRef = useRef();

  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [slugError, setSlugError] = useState(null);
  const [slugChecked, setSlugChecked] = useState(false);

  const URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const getSubdomain = () => {
      const hostname = window.location.hostname;
      const parts = hostname.split(".");
      if (parts.length >= 2) {
        return parts[0];
      }
      return null;
    };

    const checkSlug = async () => {
      const subdomain = getSubdomain();
      if (subdomain === null) {
        setSlugChecked(true);
        setSlugError("Church not found");
        return;
      }
      try {
        const res = await axios.get(URL + "/slugChecker", {
          headers: {
            "x-church-slug": subdomain,
          },
        });
        if (res) {
          setSlugChecked(true); // show form
        }
      } catch (err) {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message &&
          err.response.data.message.toLowerCase() === "church not found"
        ) {
          setSlugError("Church not found");
        } else {
          console.error("Slug check failed:", err);
          toast.error(err?.response?.data?.message);
        }
        setSlugChecked(true); // either way, we finish checking
      }
    };

    checkSlug();
  }, []);

  // function getSubdomain() {
  //   const hostname = window.location.hostname; // e.g., abc.localhost
  //   const parts = hostname.split(".");
  //   if (parts.length >= 2) {
  //     return parts[0];
  //   }
  //   return null;
  // }

  // useEffect(() => {
  //   const checkSlug = async () => {
  //     try {
  //       const subdomain = getSubdomain();

  //       const res = await axios.get("http://192.168.1.21:8080/slugChecker", {
  //         headers: {
  //           "x-church-slug": subdomain,
  //         },
  //       });

  //       console.log("Slug Check Response:", res);
  //        setSlugChecked(true);
  //     } catch (err) {
  //   if (err?.response?.data?.message?.toLowerCase() === "Church not found") {
  //           navigate("/not-found");
  //         } else {
  //           console.error("Slug check failed:", err);
  //         }
  //     }
  //   };

  //   checkSlug();
  // }, []);

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required");
      emailRef.current?.focus();
      return;
    }
    if (!password) {
      setError("Password is required");
      passwordRef.current?.focus();
      return;
    }
    setError("");

    try {
      // Call your login API here
      setLoading(true);
      const response = await AtriumApi.post(
        "/v1/login",
        {
          email,
          password,
        }
        // { withCredentials: true }
      );

      // handle storing token, updating context, redirecting, etc.
      if (response) {
        setLoading(false);
        login(response?.data?.token);
        toast.success("Login successful");
      }
    } catch (error) {
      console.log("sign error", error);

      toast.error(error?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false); // hide loader
    }
  };

  return (
    <Default
      maincard={
        !slugChecked ? (
          <div className="p-6 text-center text-lg">
            Checking church details...
          </div>
        ) : slugError ? (
          <div className="p-6 text-center text-red-600 text-xl font-semibold">
            {slugError}
          </div>
        ) : (
          <form
            onSubmit={onSubmit}
            className="w-full max-w-full flex-col items-center"
          >
            {/* Sign in section */}
            <h3 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
              Sign In
            </h3>
            <p className="mb-9 ml-1 text-base text-gray-600">
              Enter your email and password to sign in
            </p>
            {error && (
              <div
                className={`transition-all transition-discrete duration-3000 ease-in-out p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400`}
                role="alert"
              >
                <span className="font-medium">{error}</span>
              </div>
            )}

            {/* Email */}
            <InputField
              variant="auth"
              extra="mb-3"
              label="Email"
              placeholder="Your email"
              id="email"
              type="text"
              value={email || ""}
              ref={emailRef}
              onChange={(e) => setEmail(e.target.value)}
            />

            {/* Password */}
            <InputField
              variant="auth"
              extra="mb-3"
              label="Password"
              placeholder="Your password"
              id="password"
              type="password"
              value={password || ""}
              ref={passwordRef}
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* Checkbox */}
            <div className="my-6 flex items-center justify-between">
              <div className="flex items-center">
                {/* <Checkbox id="remember-me" /> */}
                {/* <label
                className="ml-2 text-sm font-medium text-navy-700 dark:text-white"
                htmlFor="remember-me"
              >
                Keep me logged In
              </label> */}
              </div>
              {/* <Link
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-brand-600 dark:hover:text-brand-500"
              to="/auth/forgot-password"
            >
              Forgot Password?
            </Link> */}
            </div>
            {loading ? (
              <div className="flex items-center justify-center">
                <Loader />
              </div>
            ) : (
              <button
                type="submit"
                className="w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-600 dark:bg-brand-700 dark:text-white dark:hover:bg-brand-600 dark:active:bg-brand-600"
              >
                Sign In
              </button>
            )}

            {/* <div className="mt-4">
            <span className="text-sm font-medium text-navy-700 dark:text-gray-500">
              Don't have an account yet?
            </span>
            <a
              href="/auth/sign-up/default"
              className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              Create an account
            </a>
          </div> */}

            {/* <div className="mb-6 flex items-center  gap-3">
            <div className="h-px w-full bg-gray-200 dark:!bg-navy-700" />
            <p className="text-base text-gray-600"> or </p>
            <div className="h-px w-full bg-gray-200 dark:!bg-navy-700" />
          </div>

          <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800 dark:text-white">
            <div className="rounded-full text-xl">
              <FcGoogle />
            </div>
            <p className="text-sm font-medium text-gray-700 dark:text-white">
              Sign In with Google
            </p>
          </div>
          <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800 dark:text-white">
            <div className="rounded-full text-xl">
              <FaApple />
            </div>
            <p className="text-sm font-medium text-gray-700 dark:text-white">
              Sign In with Apple
            </p>
          </div>
          <div className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-navy-800 dark:text-white">
            <div className="rounded-full  text-fbicon text-xl">
              <FaFacebook />
            </div>
            <p className="text-sm font-medium text-gray-700 dark:text-white">
              Sign In with Facebook
            </p>
          </div> */}
          </form>
        )
      }
    />
  );
}

export default SignInDefault;
